import React from "react";

import { useSelector } from "react-redux";

import { CalendarEvent, Legend } from "@ds-developer/calendar";

import {
  filterEventsForRange,
  numberDaysForView,
} from "@hubcapp/components/Calendar/helpers";

import { selectCalendarInitialDate, selectCalendarView } from "@hubcapp/state";

type LegendStateProviderProps = {
  // TODO - Remove this any, no idea why an imported type causes so many issues
  events: CalendarEvent[] | any[];
};

const LegendStateProvider: React.FC<LegendStateProviderProps> = ({
  events,
}) => {
  const initialDate =
    useSelector(selectCalendarInitialDate) || new Date(Date.now());
  const view = useSelector(selectCalendarView);

  const numberDays = numberDaysForView(view);

  return (
    <Legend
      events={filterEventsForRange({
        events,
        initialDate,
        numberDays,
      })}
    />
  );
};

export default LegendStateProvider;
